import React, { Component } from 'react';
import { getMultiLang } from '@platform/api';

function useLocale(DatePicker) {
    return class DatePickerWithLocale extends Component {
        constructor (props) {
            super(props);
            this.state = { locale: {} };
        }
        
        componentDidMount() {
            getMultiLang({
                moduleId: 'base_datepicker',
                callback: locale => {
                    this.setState({ locale });
                }, 
            });
        }

        render () {
            return <DatePicker {...this.props} locale={this.state.locale} />;
        }
    };
}

export default useLocale;